var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaQs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hcfsawwbta",
    width: "123.6%",
    height: "148.8%",
    x: "-11.8%",
    y: "-24.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.215686275 0 0 0 0 0.396078431 0 0 0 0 0.17254902 0 0 0 0.197388549 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hcfsawwbta)",
    transform: "translate(-890.000000, -481.000000) translate(90.000000, 236.000000) translate(770.000000, 215.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L54 0 54 54 0 54z",
    transform: "translate(30.000000, 30.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#61A351",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.438 0H5.061C2.279 0 0 2.278 0 5.063v30.375C0 38.221 2.278 40.5 5.063 40.5h30.375c2.784 0 5.062-2.278 5.062-5.063V5.064C40.5 2.277 38.222 0 35.437 0zM20.274 32.906c-1.493 0-2.657-1.19-2.657-2.658 0-1.493 1.19-2.632 2.657-2.632 1.494 0 2.633 1.139 2.633 2.632-.026 1.469-1.14 2.658-2.633 2.658zm6.328-15.618c-1.594 2.354-3.113 3.063-3.948 4.582-.33.607-.456 1.012-.456 2.987h-3.847c0-1.038-.152-2.734.658-4.177 1.037-1.848 2.987-2.936 4.126-4.556 1.215-1.721.531-4.91-2.886-4.91-2.227 0-3.341 1.695-3.797 3.113l-3.468-1.443c.962-2.86 3.519-5.29 7.24-5.29 3.113 0 5.265 1.417 6.353 3.19.937 1.543 1.468 4.378.025 6.504z",
    transform: "translate(30.000000, 30.000000) translate(6.750000, 6.750000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaQs);
export default __webpack_public_path__ + "static/media/fa-qs.1c69e3340902be23573ba51974af751e.svg";
export { ForwardRef as ReactComponent };